import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to get the list of pubkeys that a user is following
 * Queries kind 3 (contact list) events
 */
export function useFollowing(pubkey: string | undefined) {
  const { nostr } = useNostr();

  return useQuery({
    queryKey: ['following', pubkey],
    queryFn: async (c) => {
      if (!pubkey) return [];

      const signal = AbortSignal.any([c.signal, AbortSignal.timeout(3000)]);
      
      // Query kind 3 contact list events
      const events = await nostr.query(
        [{ kinds: [3], authors: [pubkey], limit: 1 }],
        { signal }
      );

      if (events.length === 0) return [];

      // Extract pubkeys from p tags
      const following = events[0].tags
        .filter(([name]) => name === 'p')
        .map(([_, pubkey]) => pubkey);

      return following;
    },
    enabled: !!pubkey,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
